export default __webpack_public_path__ + "static/media/service.4554c475.svg";